module.exports = __webpack_public_path__ + "static/media/espresso-house.bc259fff.svg";